import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Form, List, Card, Button, Radio, Checkbox, Switch } from 'antd';
import _ from 'lodash'
import $ from 'jquery'
import { SearchOutlined, CopyOutlined, FormOutlined, ShopOutlined } from '@ant-design/icons';
import './styles.module.scss';
import AppHelper from 'libs/AppHelper';
import {API_HOST}  from '../../configs/env';
import whttp    from '../../libs/whttp';
import { genFormItemAtrribute } from 'libs/FormHelper'
import { RadioControl, CheckboxControl } from '@wordpress/components'
import { withState } from '@wordpress/compose';
import bannerImage from 'assets/img/banner/banner-catalog.png';

const defaultListInfo = {
  "current": 1, //目前頁數
  "page_size": 10, //一頁幾筆
  "total": 1, //以此query條件，總共幾筆資料
  "rows": []
}
// 前端頁面
export default class CatalogueList extends Component {
  state = {
    listInfo: _.cloneDeep(defaultListInfo),
  }
  componentDidMount(){
  }
  
  render() {
    return (
      <div class="banner banner-breadcrumb">
        <div class="banner-img"><img src="assets/img/banner/banner-catalog.png" alt="促銷目錄" /></div>
        <div class="breadcrumb-inner">
          <h3>促銷目錄</h3>
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              {/* <li class="breadcrumb-item"><a href="index.html">首頁</a></li>
              <li class="breadcrumb-item"><a href="#">促銷目錄</a></li>
              <li class="breadcrumb-item"><a href="#">全部促銷目錄</a></li>
              <li class="breadcrumb-item active" aria-current="page">主題企劃</li> */}
            </ol>
          </nav>
        </div>
      </div>
    )
  }
}

// 編輯器
const listGrid = { gutter: 16, xs: 1, sm: 2, md: 4, lg: 4, xl: 4, xxl: 4, }
export class CatalogueListEditor extends Component {
  formRef = React.createRef()
  state = {
    listInfo: _.cloneDeep(defaultListInfo),
  }
  componentDidMount(){
    AppHelper.updateConfig()
    console.log('kkk', this.props.attributes)
    
    this.formRef.current.setFieldsValue(this.props.attributes)
  }
  render() {
    const listInfo = this.state.listInfo
    const options = _.get(this, 'props.app.options', {})
    console.log('editor', this.props)
    
    return (
      <div className="vu-blocks-editor">
        <h2>促銷目錄列表</h2>
        <Form
          ref={this.formRef}
          name="basic"
          className='basicForm'
          // layout="vertical"
          // onFinish={values => this.submitData(values)}
          onValuesChange={(changedFields, allFields) => this.props.setAttributes(changedFields)}
        >
          <Form.Item
            {...genFormItemAtrribute('show_category_title', '目錄標題', 'checked')}
          >
            <Switch checkedChildren="顯示" unCheckedChildren="隱藏" />
          </Form.Item>
          <Form.Item
            {...genFormItemAtrribute('category_ids', '目錄類別')}
          >
            <Checkbox.Group>
              <List
                grid={listGrid}
                dataSource={_.get(options, 'catalogue_categories', [])}
                renderItem={item => (
                  <List.Item>
                    <Checkbox value={item.id}>{item.name}</Checkbox>
                  </List.Item>
                )}
              />
            </Checkbox.Group>
          </Form.Item>
        </Form>
      </div>
      
    )
  }
}  


// WEBPACK FOOTER //
// ./src/blocks/banner/banner-breadcrumb.js